module.exports = __webpack_public_path__ + "assets/img/bananofactory_animation.5d5684761d520a0fddeb984695e093ce.gif";